import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { AllowNotificationsModalComponent } from '@app/integrations/semrush/components/allow-notifications-modal/allow-notifications-modal.component';

import { ViewportService } from './services/viewport.service';

@NgModule({
    providers: [ViewportService],
    imports: [MatDialogModule, MatButtonModule, AllowNotificationsModalComponent],
})
export class IntegrationSemrushModule {}
